"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.weak-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Map = _interopRequireDefault(require("ol/Map"));

var _Group = _interopRequireDefault(require("ol/layer/Group"));

var _antd = require("antd");

var _Window = _interopRequireDefault(require("../../../../window/base/Window/Window"));

var _NewGroupLayerForm = _interopRequireDefault(require("../../../../form/layer/new/NewGroupLayerForm/NewGroupLayerForm"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["map", "parentLayerGroup", "layerOpts", "wndStyle", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * <p>Button to create a new <i>ol/layer/Group</i> in the map.</p>
 * <p>
 *  Remark: this component also is present in the menu context 
 *  for <i>Layer Tree</i> component.
 * </p>
 * <p>
 *  Check in the <a href="https://ant.design/components/button/">documentation</a> 
 *  for additional properties for the button.
 * </p>
 * 
 * @visibleName New Layer Group Button 
 */
var NewGroupLayerButton = function NewGroupLayerButton(_ref) {
  var map = _ref.map,
      _ref$parentLayerGroup = _ref.parentLayerGroup,
      parentLayerGroup = _ref$parentLayerGroup === void 0 ? map.getLayerGroup() : _ref$parentLayerGroup,
      _ref$layerOpts = _ref.layerOpts,
      layerOpts = _ref$layerOpts === void 0 ? undefined : _ref$layerOpts,
      wndStyle = _ref.wndStyle,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  //Initialize Image Layer
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      visibleWnd = _useState2[0],
      setVisibleWnd = _useState2[1];
  /**
   * Handler to close the Window once the OK button
   * on this window is clicked
   */


  var onCloseWindow = function onCloseWindow() {
    setVisibleWnd(false);
  };
  /**
   * Handler to show the Window once the button is Clicked
   */


  var onShowWindow = function onShowWindow() {
    setVisibleWnd(true);
  };

  var onFinish = (0, _react.useCallback)(function (values) {
    setVisibleWnd(false);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, _objectSpread(_objectSpread({
      onClick: onShowWindow
    }, otherProps), {}, {
      children: children
    })), visibleWnd && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Window.default, {
      title: children,
      collapsible: true,
      onClose: onCloseWindow,
      visible: visibleWnd,
      style: wndStyle,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewGroupLayerForm.default, {
        map: map,
        parentLayerGroup: parentLayerGroup,
        layerOpts: layerOpts,
        onFinish: onFinish
      })
    })]
  });
};

NewGroupLayerButton.propTypes = {
  /**
   * The OpenLayers ol/Map where the new Layer Group will be added.
   */
  map: _propTypes.default.instanceOf(_Map.default).isRequired,

  /**
   * Layer Group where the new Layer Group will be added.
   * If not provided, the map layer group will be used.
   */
  parentLayerGroup: _propTypes.default.instanceOf(_Group.default),

  /**
   * The default options to be shown in the window for the creation of the Layer Group.
   * It is the same used as parameter in the constructor of
   * <a href="https://openlayers.org/en/latest/apidoc/module-ol_layer_Group-LayerGroup.html">
   *  ol/layer/Group
   * </a>
   */
  layerOpts: _propTypes.default.object,

  /**
   * The CSS style to be provided to the window
   */
  wndStyle: _propTypes.default.object,

  /**
   * The child node for the Button
   */
  children: _propTypes.default.node
};
var _default = NewGroupLayerButton;
exports.default = _default;